import { mapGetters } from "vuex";
// import rights from "@/utils/rights";

// authentications methods

export default {
  // data: () => ({ rights }),

  computed: mapGetters("authentication", {
    isAuthenticated: "isAuthenticated",
    getMail: "getEmail",
    username: "getName",
    roleRank: "getRoleRank",
    getRole: "getRole",
    getUserRoleId: "getUserRoleId",
  }),

  // methods: {
  //   hasAccess(right) {
  //     return this.$store.getters["authentication/hasRight"](right);
  //   },
  // },
};
